class UserEventHandler {
}
export default UserEventHandler;
//# sourceMappingURL=UserEventHandler.js.map